
import { gsap, wrap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { Draggable } from "gsap/Draggable.js";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Draggable);

import scrollEvents from "./scrollEvents";
import Swiper from 'swiper';

const mobileVieportMax = 768;

const init = () => {
    
    const sectionHomeIntro = document.querySelector('.section__home-intro');

    if(!sectionHomeIntro) return;

    let mm = gsap.matchMedia();



    // Creazione categorie virtuali per lo scroll
    const projectsCategory = document.querySelectorAll('.projects-category');
    const projectsCategorySection = document.querySelector('.section__projects-categories');

    const virtualCategories = document.createElement('div');
    virtualCategories.classList.add('projects-categories__virtual');
    projectsCategorySection.appendChild(virtualCategories);

    // Creazione categoria virtuale per l'introduzione delle categorie
    let virtualCategoriesItemFirst = document.createElement('div');
    virtualCategoriesItemFirst.classList.add('projects-category__virtual');
    virtualCategoriesItemFirst.classList.add('projects-category__virtual--first');
    virtualCategories.appendChild(virtualCategoriesItemFirst);

    // Aggiungo gli altri elementi virtuali
    projectsCategory.forEach(() => {
        let virtualCategoriesItem = document.createElement('div');
        virtualCategoriesItem.classList.add('projects-category__virtual');
        virtualCategories.appendChild(virtualCategoriesItem);
    });

    const virtualCategoriesItem = document.querySelectorAll('.projects-category__virtual:not(.projects-category__virtual--first)');

    // Animazione elementi intro
    gsap.timeline({
        scrollTrigger: {
            trigger: '.main-wrapper',
            start: "top -20px",
            end: "top -40px",
            scrub: false,
            onEnter: () => {
                gsap.to('.home-intro__info div', {
                    duration: 0.6,
                    y: -50,
                    opacity: 0,
                    ease: "quart.in",
                    stagger: 0.2,
                });
            },
            onEnterBack: () => {
                gsap.to('.home-intro__info div', {
                    duration: 0.6,
                    y: 0,
                    opacity: 1,
                    ease: "quart.out",
                    stagger: 0.2,
                });
            }
        }
    });
    
    const slidersTl = [];
    document.querySelectorAll('.projects-category__slider').forEach((slider, index) => {

        const swiperWrapper = slider.querySelector('.projects-category__slider-wrapper');
        slider.classList.add('swiper');
        swiperWrapper.classList.add('swiper-wrapper');
        slider.querySelectorAll('.projects-category__item').forEach((item) => {
            item.classList.add('swiper-slide');
        });
        
        let swiper = new Swiper(slider, {
            slidesPerView: 1.5,
            spaceBetween: 10,
            speed: 1000,
            slidesOffsetBefore: 10,
            slidesOffsetAfter: 10,
            breakpoints: {
                768: {
                    spaceBetween: 15,
                    slidesPerView: 2,
                    slidesOffsetAfter: 15,
                    allowTouchMove: false
                } 
            }
        });

        slidersTl.push(swiper);
    });

    let moveTopVal = document.querySelector('.projects-category__title').offsetHeight;

    const projectscatintroTl = gsap.timeline({
        scrollTrigger: {
            trigger: virtualCategoriesItemFirst,
            start: "top bottom",
            end: "bottom top",
            scrub: 1
        }
    });

    projectscatintroTl.to('.projects-categories', {
        top: (window.innerWidth < mobileVieportMax) ? `${moveTopVal*2}px` : `${moveTopVal}px`
    });

    const vw = window.innerWidth;


    let clicked = false;
    document.querySelectorAll('.projects-category__title').forEach((title, key) => {
            
        title.addEventListener('mousedown', () => {
            scrollEvents.scrollTo(virtualCategoriesItem[key], 1);
            clicked = true;

            setTimeout(() => {
                clicked = false;
            }, 2000);
        });

    });

    // Creo le timeline per le accordion
    virtualCategoriesItem.forEach((virtualCat, key) => {

        if(!projectsCategory[key]) return;

        const category = projectsCategory[key];
        const categoryContent = category.querySelector('.projects-category__content');

        let moveTop = key < (projectsCategory.length - 1) ? (moveTopVal*(key+1)) : (moveTopVal*(key+1) + moveTopVal);
        let moveTopBack = key < (projectsCategory.length - 1) ? (moveTopVal*(key+1)-moveTopVal) : (moveTopVal*(key+1));
        let opacityOut = 0;

        if (vw < mobileVieportMax){
            moveTop = (moveTopVal * key)+(moveTopVal);
            moveTopBack = (moveTopVal * key);
            opacityOut = 1;
        }

        const accordionTl = gsap.timeline({
            scrollTrigger: {
                trigger: virtualCat,
                start: "top top",
                end: "bottom top",
                scrub: true,
                onEnterBack: () => {
                    gsap.to(categoryContent, { height: 'auto', duration: 0.8, ease: "power2.inOut" });
                    gsap.to(category, { autoAlpha: 1, duration: 0.8, ease: "power2.inOut" });
                    gsap.to('.projects-categories', { y: `-${moveTopBack}px`, duration: 0.8, ease: "power2.inOut" });
                },
                onEnter: () => {
                    gsap.to(categoryContent, { height: 'auto', duration: 0.8, ease: "power2.inOut" });
                },
                onLeave: () => {
                    gsap.to(categoryContent, { height: 0, duration: 0.8, ease: "power2.inOut" });
                    gsap.to(category, { autoAlpha: (1-opacityOut), duration: 0.8, ease: "power2.inOut" });
                    gsap.to('.projects-categories', { y: `-${moveTop}px`, duration: 0.8, ease: "power2.inOut", onComplete: () => {

                        if (vw >= mobileVieportMax){
                            slidersTl[key].setProgress(1);
                        }
                    }});
                },
                onLeaveBack: () => {
                    if(key == 0) return;
                    gsap.to(categoryContent, { height: 0, duration: 0.8, ease: "power2.inOut" });
                },
                onUpdate: (self) => {

                    if (vw >= mobileVieportMax){

                        if(clicked == false){
                            slidersTl[key].setProgress(self.progress);
                        }
                    }
                }
            }
        });


    });
};

export default { init };